import { AnyAction } from 'redux';
import {
  App,
  determineLaufzeit,
  getVetragsOptionenFromVorvertrag,
  ThhPferdVorbelegungdaten,
  Vertragsoptionen,
} from '@ps20-frontend/frontend-models';
import { GlobalActions, TARIF_CHECKED } from '@ps20-frontend/shop-integration-redux';
import { addVorvertragToAngeboteReducer, vertragsoptionenReducer } from '@ps20-frontend/reducers';
import { Selbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { ThhPferdActions } from '../thhPferdActions';

export const thhPferdVertragsoptionenReducer = function (
  sectionState: Vertragsoptionen = null,
  action: AnyAction,
  state: IAppState,
): Vertragsoptionen {
  sectionState = vertragsoptionenReducer(sectionState, action, App.THH_PFERD, state);
  switch (action.type) {
    case ThhPferdActions.SELBSTBETEILIGUNG_CHANGED: {
      const selbstbeteiligung: Selbstbeteiligung = action.payload;
      return { ...sectionState, selbstbeteiligung };
    }
    case TARIF_CHECKED: {
      const newState: Vertragsoptionen = { ...sectionState };
      determineLaufzeit(action, newState, state.produkt, sectionState);
      return newState;
    }
    case ThhPferdActions.VERSICHERUNGSSUMME_CHANGED: {
      const newState: Vertragsoptionen = { ...sectionState };
      newState.versicherungssumme = action.payload.versSummeLeistung;
      return newState;
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      return addVorvertragToAngeboteReducer(sectionState, action, App.THH_PFERD);
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: ThhPferdVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.THH_PFERD) {
        const newState: Vertragsoptionen = getVetragsOptionenFromVorvertrag(
          sectionState,
          actionPayload,
        );
        return { ...newState };
      }
      return sectionState;
    }
    case GlobalActions.THH_PFERD_VORBELEGUNG_FINISHED: {
      const actionPayload: ThhPferdVorbelegungdaten = action.payload.vorhandeneVorbelegungdaten;
      return {
        ...sectionState,
        urbeginn: actionPayload?.urbeginn,
      };
    }
    default:
      return sectionState;
  }
};
